import Accordion from './accordion-config';
import Media from './media';

export default class FAQ {
  internalName?: string;
  title?: string;
  textColor?: string;
  icon?: Media;
  items?: any;

  constructor(props: any) {
    const { internalName, textColor, icon, itemsCollection, title } = props;
    this.internalName = internalName || '';
    this.title = title || '';
    this.textColor = textColor || '#000';
    this.icon = new Media(icon);
    this.items = itemsCollection?.items?.map(
      (item: any): Accordion => new Accordion(item)
    );
  }
}
